import { Component, Input, TemplateRef } from '@angular/core';
import { Message } from './models/message.model';
import { MailService } from './services/mail.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'FocusCovid19';

  private _ms;
 public message: Message;


  constructor(ms: MailService) {
      this._ms = ms;
      this.message = new Message();
      this.message.SenderName = "";
      this.message.SenderEmail = "";
      this.message.SenderPhone = "";
      this.message.SenderComment = "";
    }


    openDialog(){

    }
  sendMail(): void {

console.log(this.message);
    if(this.message !== null && this.message.SenderName !== ""){
      this._ms.sendMail(this.message);
      alert("Mensagem enviada com sucesso!");
      this.message = new Message();
      this.message.SenderName = "";
      this.message.SenderEmail = "";
      this.message.SenderPhone = "";
      this.message.SenderComment = "";
    }
  }


}
